import React, {createContext, FC, useContext} from 'react';
import {FaqRefHandle} from '../types/components/faq-list';

export const useFaqListContext = (): FaqListContextValue => {
  const contextValue = useContext(FaqListContext);
  if (contextValue === undefined) {
    throw new Error('context provider missing');
  }

  return contextValue;
};

interface FaqListContextValue {
  refHandle: React.MutableRefObject<null | FaqRefHandle>;
}

export const FaqListContext =
  createContext<undefined | FaqListContextValue>(undefined);

interface FaqListContextProviderProps {
  children?: React.ReactNode;
}

export const FaqListContextProvider: FC<FaqListContextProviderProps> = (
  props
) => {
  // The handle API is going to be implemented by the brand's <FaqList>
  const refHandle = React.useRef<FaqRefHandle | null>(null);

  const value = React.useMemo(() => ({refHandle}), [refHandle]);

  return (
    <FaqListContext.Provider value={value}>
      {props.children}
    </FaqListContext.Provider>
  );
};
export default FaqListContextProvider;
